import React from "react";
import { Button, Card, Col, Empty, Row, Space, Statistic, Tag, Typography } from "antd";
import { PlusOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { attendancePlannerPolicyDependencies } from "../policyDependencyConfig";

const { Paragraph, Text, Title } = Typography;

const PreparePolicyEffects = (props) => {
  const deductionCount = props.relatedData?.deduction_types?.length || 0;
  const encashmentCount = props.relatedData?.encashment_types?.length || 0;
  const policyPackages = props.relatedData?.policy_planers?.data || props.relatedData?.policy_planers || [];

  const getItemName = (item) => item?.name || item?.title || item?.code || `#${item?.id}`;

  const renderNameList = (items, emptyText, onClick) => {
    if (!items?.length) {
      return <Empty image={ Empty.PRESENTED_IMAGE_SIMPLE } description={ emptyText } />;
    }

    return (
      <Space wrap size={ [8, 8] }>
        { items.slice(0, 8).map((item) => (
          <Tag
            key={ item.id || getItemName(item) }
            className={ onClick ? "attendance-policy-guide__tag attendance-policy-guide__tag--clickable" : "attendance-policy-guide__tag" }
            onClick={ onClick ? () => onClick(item) : undefined }
          >
            { getItemName(item) }
          </Tag>
        )) }
        { items.length > 8 ? <Tag>+{ items.length - 8 } more</Tag> : null }
      </Space>
    );
  };

  return (
    <div className="attendance-policy-guide">
      <div className="attendance-policy-guide__header">
        <Title level={ 4 }>Prepare salary effects</Title>
        <Paragraph>
          First create the reusable salary effects HR will use inside attendance rules.
        </Paragraph>
      </div>

      <Row gutter={ [16, 16] }>
        <Col xs={ 24 } md={ 12 }>
          <Card className="attendance-policy-guide__card" bordered={ false }>
            <Space direction="vertical" size={ 12 } style={ { width: "100%" } }>
              <Statistic title="Deduction effects ready" value={ deductionCount } />
              <Text type="secondary">
                Use this for absent, missing attendance, late arrival, early leaving, short hours, relaxation, and deductible leave.
              </Text>
              <Button
                icon={ <PlusOutlined /> }
                onClick={ () => props.onCreateSetup("deductionType") }
              >
                Add salary deduction effect
              </Button>
            </Space>
          </Card>
        </Col>

        <Col xs={ 24 } md={ 12 }>
          <Card className="attendance-policy-guide__card" bordered={ false }>
            <Space direction="vertical" size={ 12 } style={ { width: "100%" } }>
              <Statistic title="Earning effects ready" value={ encashmentCount } />
              <Text type="secondary">
                Use this for approved overtime payment or compensatory leave conversion.
              </Text>
              <Button
                icon={ <PlusOutlined /> }
                onClick={ () => props.onCreateSetup("encashmentType") }
              >
                Add overtime earning effect
              </Button>
            </Space>
          </Card>
        </Col>
      </Row>

      <Card
        className="attendance-policy-guide__card"
        bordered={ false }
        title="Existing attendance rules"
      >
        <Row gutter={ [12, 12] }>
          { attendancePlannerPolicyDependencies.map((dependency) => {
            const rules = props.relatedData?.[dependency.relatedListKey] || [];
            return (
              <Col xs={ 24 } md={ 12 } xl={ 8 } key={ dependency.key }>
                <div className="attendance-policy-guide__rule-box">
                  <Space direction="vertical" size={ 8 } style={ { width: "100%" } }>
                    <Space align="center" className="attendance-policy-guide__rule-heading">
                      <Text strong>{ dependency.label } rules</Text>
                      <Tag color={ rules.length ? "green" : "default" }>{ rules.length }</Tag>
                    </Space>
                    { renderNameList(
                      rules,
                      `No ${dependency.label.toLowerCase()} rules yet`,
                      (rule) => props.onPreviewRule(dependency, rule)
                    ) }
                  </Space>
                </div>
              </Col>
            );
          }) }
        </Row>
      </Card>

      <Card
        className="attendance-policy-guide__card"
        bordered={ false }
        title="Existing employee policy packages"
      >
        { renderNameList(
          policyPackages,
          "No policy package has been created yet",
          (policyPackage) => props.onPreviewPackage(policyPackage)
        ) }
      </Card>

      <Row justify="end" className="attendance-policy-guide__footer">
        <Button type="primary" icon={ <ArrowRightOutlined /> } onClick={ props.onNext }>
          Continue to attendance rules
        </Button>
      </Row>
    </div>
  );
};

export default PreparePolicyEffects;
